export default __webpack_public_path__ + "B-Rshapes.png";